import { CSSProperties, useMemo } from 'react';
import Image from 'next/image';
import { getAvatarVars, toFullSteamAvatar } from '@/utils/avatar';

interface Props {
    seed: string | number;
    src?: string | null;
    alt?: string;
    size?: number;
    /** Rounded-square shape (Fluent jackpot/chat look) instead of a circle. */
    square?: boolean;
    className?: string;
}

const AbstractAvatar = ({ seed, src, alt = '', size = 40, square = false, className = '' }: Props) => {
    const vars = useMemo(() => getAvatarVars(seed), [seed]);
    const normalized = useMemo(() => toFullSteamAvatar(src), [src]);
    const shape = square ? 'rounded-[28%]' : 'rounded-full';

    if (normalized) {
        return (
            <Image
                src={normalized}
                alt={alt}
                width={size}
                height={size}
                className={`${shape} object-cover shrink-0 ${className}`}
                style={{ width: size, height: size }}
            />
        );
    }

    return (
        <div
            className={`abstract-avatar ${square ? 'aa-square' : ''} ${className}`}
            style={{ width: size, height: size, ...(vars as CSSProperties) }}
            aria-label={alt}
        />
    );
};

export default AbstractAvatar;
